import {
  type TransactionGroup,
  Transaction_Type,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../../styled-system/css";
import { formatTimestamp } from "../../../libs/date";
import { t } from "../../../libs/i18n";
import { formatNumber } from "../../../libs/utils";
import { Cell } from "./cell";
import { CellFundSources } from "./cell-fundsources";

type PSInternalPaymentTransactionDetailProps = {
  transactionGroup: TransactionGroup;
};

export function PSInternalPaymentTransactionDetail({
  transactionGroup,
}: PSInternalPaymentTransactionDetailProps) {
  const summaryDetail = transactionGroup.transactionDetails[0];
  const reason = summaryDetail.transaction?.reason;

  const amount = transactionGroup.transactionDetails
    .filter((d) => d.transaction?.type === Transaction_Type.PAYMENT_PSINTERNAL)
    .reduce((acc: number, ts) => acc + Number(ts.transaction?.amount || 0), 0);

  return (
    <div
      className={css({
        bg: "white",
        px: "16px",
        rounded: "16px",
      })}
    >
      <Cell label={t("取引種別")} value={t("ポイント利用")} />
      <Cell
        label={t("利用ポイント")}
        value={`${formatNumber(-amount)}pt`}
        styles={{
          borderBottom: "none",
        }}
      />
      <CellFundSources transactionGroup={transactionGroup} />
      {reason && <Cell label={t("利用理由")} value={reason} />}
      <Cell
        label={t("利用日時")}
        value={formatTimestamp(summaryDetail.transaction?.createdAt)}
      />
      <Cell label={t("取引ID")} value={transactionGroup.id} lastChild={true} />
    </div>
  );
}
